module.exports = __webpack_public_path__ + "img/gplay.2495bcbe.svg";